export default class DtoMeasure {
    constructor(obj) {
        this.id = obj.id || obj.pluvioId
        this.measureDate = obj.measureDate || obj.date
        this.value = obj.value
        this.unit = obj.unit
        this.dataType = obj.dataType
    }
}